<template>
  <div class="header-wrap">
    <div class="header-line"></div>
    <header class="header">
      <div class="header-inner">
        <!-- LOGO -->
        <div class="logo">
          <img src="../assets/header-logo.png" alt="" />
        </div>
        <!-- 主导航 -->
        <nav class="nav">
          <router-link to="/" exact-active-class="nav-active" class="nav-link">首页</router-link>
          <router-link to="/features" exact-active-class="nav-active" class="nav-link">功能介绍</router-link>
          <router-link to="/download" exact-active-class="nav-active" class="nav-link">产品下载中心</router-link>
          <router-link to="/cases" exact-active-class="nav-active" class="nav-link">合作案例</router-link>
          <router-link to="/pricing" exact-active-class="nav-active" class="nav-link">产品定价</router-link>
<!--          <router-link to="/personal" exact-active-class="nav-active" class="nav-link">个人版产品</router-link>-->
          <span @click="toggleTerminal" class="nav-link">个人版产品</span>
        </nav>
        <!-- 登录链接 -->
        <div class="header-login">
          <a href="https://agent.zzyxzs.com" target="_blank" class="login-link">代理商登录</a>
          <a href="https://sh.zzyxzs.com" target="_blank" class="login-link">商户登录</a>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import {EventBus} from "@/main";

export default {
  name: 'Header',
  methods: {
    toggleTerminal () {
      // 通过事件总线触发切换终端事件
      EventBus.$emit('toggleTerminal')
    }
  }
}
</script>

<style scoped>
.header-wrap {
  width: 100%;
  background: #fff;
}
.header-line {
  width: 100%;
  height: 1px;
  background: #e5e6eb;
}
.header {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  background: #fff;
  box-sizing: border-box;
}
.header-inner {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
}
.logo {
  display: flex;
  align-items: center;
  gap: 6px;
}
.logo-zz {
  color: #444444;
  font-weight: bold;
  font-size: 22px;
  font-family: 'Arial Black', 'Arial', sans-serif;
  letter-spacing: 1px;
}
.logo-text {
  color: #222;
  font-size: 18px;
  font-weight: bold;
  margin-left: 2px;
}
.nav {
  display: flex;
  align-items: center;
  gap: 32px;
}
.nav-link {
  color: #222;
  font-size: 15px;
  text-decoration: none;
  padding: 0 2px 6px 2px;
  position: relative;
  transition: color 0.2s;
  cursor: pointer;
}
.nav-link:hover,
.nav-link.nav-active {
  color: #444444;
}
.nav-link.nav-active{
  font-weight: 700;
}
.nav-link.nav-active::after,
.nav-link:hover::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 2px;
  background: #2667e5;
  border-radius: 2px;
}
.header-login {
  display: flex;
  align-items: center;
  gap: 18px;
}
.login-link {
  color: #2667e5;
  font-size: 14px;
  text-decoration: none;
  transition: color 0.2s;
}
.login-link:hover {
  color: #2667e5;
}
@media (max-width: 1200px) {
  .header-inner {
    width: 100%;
    padding: 0 16px;
  }
}
@media (max-width: 768px) {
  .header-inner {
    flex-direction: column;
    height: auto;
    gap: 10px;
    padding: 8px 0;
  }
  .nav {
    gap: 16px;
  }
}
</style>
